/*****************************************************************************
 *
 * Simple selector functions that abstract the location of store values for
 * ease of refactoring and less brittle code
 *
 *****************************************************************************/

import _ from 'lodash'
import {VARIABLES} from "../utilities/constants";

export const isLoading = store => {
  return store.loading
}

export const getDisplayType = store => {
  return store.displayType
}

export const getSummaryType = store => {
  return store.summaryType
}

export const getSelectedCost = store => {
  return store.selectedCost
}

export const getSelectedStateFips = store => {
  return store.selectedStateFips
}

export const getComparisonStateFips = store => {
  return store.comparisonStateFips
}

export const getSelectedCountyFips = store => {
  return store.selectedCountyFips
}

export const getComparisonCountyFips = store => {
  return store.comparisonCountyFips
}

export const getNationalData = store => {
  return store.nationalData
}

export const getStatesData = store => {
  return store.statesData
}

export const getCountiesData = store => {
  return store.countiesData
}

export const getSelectedState = store => {
  return _.find(getStatesData(store), [VARIABLES.StateID, getSelectedStateFips(store)])
}

export const getComparisonState = store => {
  return _.find(getStatesData(store), [VARIABLES.StateID, getComparisonStateFips(store)])
}

export const getSelectedCounty = store => {
  return _.find(getCountiesData(store), [VARIABLES.CountyID, getSelectedCountyFips(store)])
}

export const getComparisonCounty = store => {
  return _.find(getCountiesData(store), [VARIABLES.CountyID, getComparisonCountyFips(store)])
}


